export const shouldClear = (props, nextProps) => !nextProps.error && nextProps.fetching !== props.fetching && nextProps.fetching === false;
